import {
  GETALL_TIPOS_DOCUMENTOS,
  LOADING_GETALL_TIPOS_DOCUMENTOS,
  ACTIVO_TIPOS_DOCUMENTOS,
} from '../../../store/Types';
import {
  deleteTiposDocumentosService,
  getAllTiposDocumentosService,
  getOneTiposDocumentosService,
  saveTiposDocumentosService,
} from '../../../services';
import { tryCatchHelper } from '../../../helpers';

export const getAllTiposDocumentosAction = async (dispatch, entityId) => {
  try {
    dispatch({
      type: LOADING_GETALL_TIPOS_DOCUMENTOS,
      payload: true,
    });
    const res = await getAllTiposDocumentosService({ entityId });
    if (res.status === 200) {
      dispatch({
        type: GETALL_TIPOS_DOCUMENTOS,
        payload: res.data,
      });
      dispatch({
        type: LOADING_GETALL_TIPOS_DOCUMENTOS,
        payload: false,
      });
      return res.data;
    }
    dispatch({
      type: LOADING_GETALL_TIPOS_DOCUMENTOS,
      payload: false,
    });
    return null;
  } catch (e) {
    dispatch({
      type: LOADING_GETALL_TIPOS_DOCUMENTOS,
      payload: false,
    });
    let message =
      e.response?.data?.message ||
      e.message ||
      'Error al intentar, realizar el proceso';
    if (Array.isArray(e.message)) message = e.message.join(', ');
    if (Array.isArray(e.response?.data?.message)) {
      message = e.response?.data?.message.join(', ');
    }
    console.warn(message);
  }
};

export const saveTiposDocumentosAction = async (
  { dispatch, addNotification },
  entityId,
  id,
  data
) => {
  try {
    const res = await saveTiposDocumentosService(id, data);
    addNotification(
      res.message ?? id
        ? 'El tipo de documento actualizado.'
        : 'El tipo de documento registrado.'
    );
    await getAllTiposDocumentosAction(dispatch, entityId);
    return true;
  } catch (e) {
    tryCatchHelper({ e, addNotification });
    return false;
  }
};

export const setActivoTiposDocumentosAction = async (dispatch, data) => {
  dispatch({
    type: ACTIVO_TIPOS_DOCUMENTOS,
    payload: data,
  });
};

export const getOneTiposDocumentosAction = async (dispatch, id) => {
  try {
    const res = await getOneTiposDocumentosService(id);
    if (res.status === 200) {
      await setActivoTiposDocumentosAction(dispatch, res.data);
      return true;
    }
    return false;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteTiposDocumentosAction = async (
  { dispatch, addNotification },
  id,
  entityId
) => {
  try {
    const res = await deleteTiposDocumentosService(id, entityId);
    if (res.status === 200) {
      addNotification(res.data?.message ?? 'Tipo de documento eliminado.');
      await setActivoTiposDocumentosAction(dispatch, null);
      await getAllTiposDocumentosAction(dispatch, entityId);
      return true;
    }
    return false;
  } catch (e) {
    tryCatchHelper({ e, addNotification });
    return false;
  }
};
